'use client';

import { c as _c } from "react/compiler-runtime";
import { lazy, useEffect, useRef, useState } from 'react';
import { useCookieConsent } from '@/hooks/useCookieConsent';
import { gsap } from '@/lib/gsap';
import css from './style.module.scss';
const AnimatedButton = lazy(() => import('@/components/shared/AnimatedButton'));
const ProgressButton = lazy(() => import('./ProgressButton'));
enum COOKIE_STATE {
  UNKNOWN = 'unknown',
  DECLINE = 'declined',
}
const CookieBanner = () => {
  const $ = _c(30);
  const [show, setShow] = useState(false);
  const [cookieState, setCookieState] = useState(COOKIE_STATE.UNKNOWN);
  const bannerRef = useRef(null);
  const {
    status,
    accept,
    decline,
    isLoaded
  } = useCookieConsent();
  let t0;
  if ($[0] !== isLoaded || $[1] !== status) {
    t0 = () => {
      if (isLoaded && status === null) {
        setShow(true);
        gsap.fromTo(bannerRef.current, {
          y: 50,
          opacity: 0
        }, {
          y: 0,
          opacity: 1,
          duration: 0.6,
          ease: "power3.out"
        });
      } else {
        setShow(false);
      }
    };
    $[0] = isLoaded;
    $[1] = status;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[3] !== status) {
    t1 = [status];
    $[3] = status;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  useEffect(t0, t1);
  let t2;
  if ($[5] !== cookieState || $[6] !== decline) {
    t2 = () => {
      if (cookieState === COOKIE_STATE.UNKNOWN) {
        setCookieState(COOKIE_STATE.DECLINE);
        return;
      }
      decline();
    };
    $[5] = cookieState;
    $[6] = decline;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const handleDecline = t2;
  let t3;
  if ($[8] !== accept || $[9] !== cookieState) {
    t3 = () => {
      if (cookieState === COOKIE_STATE.DECLINE) {
        setCookieState(COOKIE_STATE.UNKNOWN);
        return;
      }
      accept();
      gsap.to(bannerRef.current, {
        y: 50,
        opacity: 0,
        duration: 0.4,
        ease: "power2.in",
        onComplete: () => {
          localStorage.setItem("cookie_consent", "true");
          setShow(false);
        }
      });
    };
    $[8] = accept;
    $[9] = cookieState;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  const handleAccept = t3;
  if (!isLoaded || !show) {
    return null;
  }
  const t4 = cookieState === COOKIE_STATE.UNKNOWN ? "Guess what? Yep\u2014cookies" : "Oh, cookies";
  let t5;
  if ($[11] !== t4) {
    t5 = <p className={css.heading}>{t4}</p>;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== cookieState) {
    t6 = <div>{cookieState === COOKIE_STATE.UNKNOWN ? <><p>We use cookies—both personal and non-personal—as described in our{" "}<a href="/privacy-policy" target="_blank" rel="noreferrer">Privacy Policy</a>{" "}to keep the Q-website running smoothly, and the others to see how much you vibe with our work, style, and soul—Chubiq.</p><p>If you agree, hit “Accept” so we can measure what’s working and tailor some ads your way.</p></> : <p>If you don’t accept our{" "}<a href="/privacy-policy" target="_blank" rel="noreferrer">Privacy Policy</a>, you might not be able to fully use our services. Just a heads-up: by completing registration on our website, you’re automatically agreeing to all the terms.</p>}</div>;
    $[13] = cookieState;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t5 || $[16] !== t6) {
    t7 = <div className={css.content}>{t5}{t6}</div>;
    $[15] = t5;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  const t8 = cookieState === COOKIE_STATE.UNKNOWN ? "Accept" : "Turn back";
  let t9;
  if ($[18] !== handleAccept || $[19] !== t8) {
    t9 = <AnimatedButton className={css.accept} onClick={handleAccept}>{t8}</AnimatedButton>;
    $[18] = handleAccept;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  const t10 = cookieState === COOKIE_STATE.DECLINE;
  let t11;
  if ($[21] !== handleDecline || $[22] !== t10) {
    t11 = <ProgressButton progress={t10} className={css.decline} onClick={handleDecline}>Decline</ProgressButton>;
    $[21] = handleDecline;
    $[22] = t10;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== t11 || $[25] !== t9) {
    t12 = <div className={css.buttons}>{t9}{t11}</div>;
    $[24] = t11;
    $[25] = t9;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] !== t12 || $[28] !== t7) {
    t13 = <div ref={bannerRef} className={css.bannerWrapper}><div className={css.banner}>{t7}{t12}</div></div>;
    $[27] = t12;
    $[28] = t7;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  return t13;
};
export default CookieBanner;